import * as signalR from "@microsoft/signalr";
import { API_CONFIG } from "../constants/config";

// Create a connection builder without starting it
export const createConnection = (username: string) => {
  return new signalR.HubConnectionBuilder()
    .withUrl(`${API_CONFIG.SIGNALR_HUB_URL}?username=${encodeURIComponent(username)}`, { withCredentials: false })
    .withAutomaticReconnect()
    .configureLogging(signalR.LogLevel.Information)
    .build();
};
